import cookie from 'react-cookies';

export const setCookie = (name, value, options = { path: '/' }) => {
  cookie.save(name, value, options);
};
export const getCookie = (name) => {
  return cookie.load(name);
};

export const removeCookie = (name, options = { path: '/' }) => {
  cookie.remove(name, options);
};
